import { useMemo } from "react"
import { useGetBuildingsQuery } from "../../services/bClientApi"
import { BuildingEntryType } from "../../Types/buildingTypes"

export default function useBuildingSelectValues() {
    const { data: buildingsData } = useGetBuildingsQuery({
        buildingsQuery: {},
        pagination: { page: 1, limit: 1000 }
    })

    const buildingOptions = useMemo(() => {
        if (!buildingsData?.docs) return []
        return buildingsData.docs.map((building: BuildingEntryType) => ({
            value: building._id,
            text: building.title,
        }))
    }, [buildingsData])

    return buildingOptions
}
